// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"JordanForm_wrapper__XqXKP"};